import React, { useState, useEffect } from 'react';
import { Toast as BSToast, ToastContainer } from 'react-bootstrap';
import './toast.scss';

const Toast = ({ show, onClose, message, variant = 'info', duration = 5000 }) => {
    useEffect(() => {
        if (show && duration > 0) {
            const timer = setTimeout(() => {
                onClose();
            }, duration);
            return () => clearTimeout(timer);
        }
    }, [show, duration, onClose]);

    const getVariantStyles = () => {
        switch (variant) {
            case 'success':
                return { bg: 'success', icon: '✓' };
            case 'warning':
                return { bg: 'warning', icon: '⚠' };
            case 'danger':
                return { bg: 'danger', icon: '✕' };
            case 'info':
            default:
                return { bg: 'info', icon: 'ℹ' };
        }
    };

    const { bg, icon } = getVariantStyles();

    return (
        <ToastContainer
            className="p-3"
            position="top-end"
            style={{ zIndex: 9999 }}
        >
            <BSToast
                bg={bg}
                onClose={onClose}
                show={show}
            >
                <BSToast.Header>
                    <strong className="me-auto">
                        <span className="me-2">{icon}</span>
                        {variant === 'info' ? 'Notice' : variant.charAt(0).toUpperCase() + variant.slice(1)}
                    </strong>
                </BSToast.Header>
                <BSToast.Body className={bg === 'warning' ? 'text-dark' : 'text-white'}>
                    {message}
                </BSToast.Body>
            </BSToast>
        </ToastContainer>
    );
};

export default Toast;

// Custom hook for easy toast management
export const useToast = () => {
    const [toastState, setToastState] = useState({
        show: false,
        message: '',
        variant: 'info'
    });

    const showToast = (message, variant = 'info') => {
        setToastState({ show: true, message, variant });
    };

    const hideToast = () => {
        setToastState(prev => ({ ...prev, show: false }));
    };

    return {
        toastState,
        showToast,
        hideToast
    };
};
